import { useEffect, useRef } from 'react';
import { makeRequest } from './client';
import { usePage } from '@inertiajs/inertia-react';

const useSessionHeartbeat = () => {
  const intervalRef = useRef(null);
  const isSendingRef = useRef(false);
  const interval = 3 * 60 * 1000; // Run the heartbeat every 3 minutes

  useEffect(() => {
    const sendHeartbeat = async () => {
      if (isSendingRef.current) return;

      try {
        isSendingRef.current = true;
        await makeRequest(route('sessionhearbeat.send'), 'post');
      } catch (err) {
        if (err == 'Error: 401') {
          window.location.href = '/login';
          return;
        }
      } finally {
        isSendingRef.current = false;
      }
    };

    sendHeartbeat();

    intervalRef.current = setInterval(() => {
      sendHeartbeat();
    }, interval);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [interval]);
};

export default useSessionHeartbeat;
